export const templatesSuggestionsDictionary = {
  space: "space",
  name: "name",
  slug: "ID",
} as { [key: string]: string };

export const sortItemOrder = ["name", "space"];
